/* eslint-disable react/jsx-no-target-blank */
import Female from 'assets/img/mex/auto/gen-female.png';
import Male from 'assets/img/mex/auto/gen-male.png';
import classNames from 'classnames';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import moment from 'moment';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useToasts } from 'react-toast-notifications';
import { SimpleWrapper } from '../InputsMex/containers';
import { DropDownDate, PrimeTextInput, TextInput } from '../InputsMex/inputs';
import { emailRegex, inputNumericoEnteros } from '../InputsMex/validaciones';
import InformacionAgente from './InformacionAgente';
import './styles.scss';

const defaultDisclaimer =
  'Al enviar mis datos autorizo que AIG Seguros México, S.A. de C.V. me contacte vía' +
  ' telefónica a través de un asesor de seguros para seguimiento o apoyo a mi cotización. Para tu tranquilidad y' +
  ' atención recibirás una llamada del teléfono AIG  55 54 88 47 00. ¡Gracias por tu confianza!';

const requiredMessage = 'Este campo es obligatorio';
const nombreErrMsg =
  'Solo se puede ingresar: mayúsculas, minúsculas, números, " . ", " - " y " & " ';

const regexNombreCompleto = RegExp(/^[a-zA-ZáÁéÉíÍóÓúÚñÑüÜ.& \-\w]+$/);

const MisDatosForm = ({
  disclaimer = defaultDisclaimer,
  title = 'Datos personales',
  inputs = [],
  overrideInputs = [],
  dateProps = {
    maxDate: moment().subtract(18, 'years').toDate(),
  },
  dateRules = {
    required: 'Campo obligatorio',
  },
  dateHelpText = '',
  nombreRules = {},
  usuTelefonoProps = {},
  clavesAgente = [],
}) => {
  const { addToast } = useToasts();

  const [labelBtn, setLabelBtn] = useState('Continuar');

  const methods = useFormContext();

  const getOverrideInput = (inputCod, defaultInput = {}) => {
    const input = overrideInputs?.find((item) => item.input === inputCod);
    if (input) return input;
    return defaultInput;
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 card-login-mex py-4">
          <div className="container-accidentes">
            <h3 className="font-mex" style={{ fontSize: '30px' }}>
              {title}
            </h3>
          </div>

          {inputs.includes('usuGenero') && (
            <div className="form-group">
              <br></br>
              <Controller
                name="datosCliente.usuGenero"
                control={methods.control}
                defaultValue="male"
                rules={{ required: 'Este campo es obligatorio' }}
                render={({ value, onChange }) => (
                  <div className="col-md-6 ">
                    <label
                      class="accidentes text-left"
                      for="datosCliente.usuGenero"
                      style={{ fontSize: '20px' }}
                    >
                      Género
                    </label>
                    <div className="row text-center">
                      <div
                        className="col-6 p-4 cpointer"
                        onClick={() => {
                          onChange('male');
                        }}
                      >
                        <img
                          className={classNames({
                            'container-genero': true,
                            selected: value === 'male',
                          })}
                          src={Male}
                          alt=""
                        />
                        <h4 className="font-mex text-center">Masculino</h4>
                      </div>

                      <div
                        className="col-6 p-4 h-100 cpointer"
                        onClick={() => {
                          onChange('female');
                        }}
                      >
                        <img
                          className={classNames({
                            'container-genero': true,
                            selected: value === 'female',
                          })}
                          src={Female}
                          alt=""
                        />
                        <h4 className="font-mex">Femenino</h4>
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
          )}

          {inputs.includes('usuNombre') && (
            <div className="form-group">
              <SimpleWrapper label="Nombre completo" name="datosCliente.usuNombre">
                <TextInput
                  inputProps={{
                    name: 'datosCliente.usuNombre',
                  }}
                  rules={{
                    required: requiredMessage,
                    pattern: {
                      value: regexNombreCompleto,
                      message: nombreErrMsg,
                    },
                    validate: {
                      validacionNombre: (value) => {
                        if (value === '' || value === undefined || value === null) {
                          setLabelBtn('Continuar');
                        } else {
                          const primerNombre = value.split(' ')[0];
                          setLabelBtn(`Gracias ${primerNombre},  vamos a cotizar!`);
                        }

                        const isValid = regexNombreCompleto.test(value);
                        if (!isValid) {
                          return nombreErrMsg;
                        }
                        return true;
                      },
                    },
                    ...nombreRules,
                  }}
                />
              </SimpleWrapper>
            </div>
          )}

          {inputs.includes('usuFechaNacimiento') && (
            <div className="form-group mx-4">
              <SimpleContainer
                label="Fecha de nacimiento"
                name="datosCliente.usuFechaNacimiento"
                helpText={dateHelpText}
              >
                <DropDownDate
                  name="datosCliente.usuFechaNacimiento"
                  rules={dateRules}
                  {...dateProps}
                />
              </SimpleContainer>
            </div>
          )}

          {inputs.includes('usuCodigoPostal') && (
            <React.Fragment>
              <div className="form-group">
                <SimpleWrapper label="Código postal" name="datosCliente.CodPostal">
                  <PrimeTextInput
                    name="datosCliente.CodPostal"
                    rules={{
                      required: requiredMessage,
                      minLength: {
                        value: 4,
                        message: 'Debe ingresar mínimo 4 números',
                      },
                      maxLength: {
                        value: 10,
                        message: 'Solo puede ingresar máximo 10 números',
                      },
                    }}
                  />
                </SimpleWrapper>
              </div>
            </React.Fragment>
          )}

          {inputs.includes('usuTelefono') && (
            <React.Fragment>
              <div className="form-group">
                <SimpleWrapper label="Teléfono" name="datosCliente.usuTelefono">
                  <PrimeTextInput
                    name="datosCliente.usuTelefono"
                    rules={{
                      required: requiredMessage,
                      minLength: {
                        value: 10,
                        message: 'Debe ingresar mínimo 10 números',
                      },
                      maxLength: {
                        value: 20,
                        message: 'Solo puede ingresar máximo 20 números',
                      },
                    }}
                    {...usuTelefonoProps}
                  />
                </SimpleWrapper>
              </div>

              <div className="form-group container-accidentes">
                <p
                  className="text-enviar-cotizacion"
                  style={{ fontSize: '20px', fontFamily: 'Futura-Medium' }}
                >
                  Compártenos tu correo para enviarte tu cotización
                </p>
              </div>
            </React.Fragment>
          )}

          {inputs.includes('usuTelefono2') && (
            <React.Fragment>
              <div className="form-group container-accidentes">
                <p
                  className="text-enviar-cotizacion"
                  style={{ fontSize: '20px', fontFamily: 'Futura-Medium' }}
                >
                  Compártenos tu contacto para enviarte tu cotización
                </p>
              </div>
              <div className="form-group">
                <SimpleWrapper label="Teléfono" name="datosCliente.usuTelefono">
                  <TextInput
                    inputProps={{
                      name: 'datosCliente.usuTelefono',
                      type: 'number',
                      onKeyDown: inputNumericoEnteros,
                    }}
                    extrasClasses="hide-arrows"
                    rules={{
                      required: requiredMessage,
                      minLength: {
                        value: 10,
                        message: 'Debe ingresar mínimo 10 números',
                      },
                      maxLength: {
                        value: 20,
                        message: 'Solo puede ingresar máximo 20 números',
                      },
                    }}
                  />
                </SimpleWrapper>
              </div>
            </React.Fragment>
          )}

          {inputs.includes('usuCorreo') && (
            <div className="form-group">
              <SimpleWrapper label="Correo" name="datosCliente.usuCorreo">
                <TextInput
                  inputProps={{
                    name: 'datosCliente.usuCorreo',
                  }}
                  rules={{
                    validate: {
                      email: (value) => {
                        if (value === '') {
                          return requiredMessage;
                        }
                        const valid = emailRegex.test(value);
                        if (!valid) {
                          return 'Ingrese un correo válido';
                        }
                        return true;
                      },
                    },
                  }}
                />
              </SimpleWrapper>
            </div>
          )}

          {inputs.includes('usuContratante') && (
            <div className="form-group">
              <SimpleWrapper
                label={
                  getOverrideInput('contratante', {
                    label: 'Contratante',
                  }).label
                }
                name="datosCliente.contratante"
              >
                <TextInput
                  inputProps={{
                    name: 'datosCliente.contratante',
                    onKeyDown: (evt) => {
                      const isValid = regexNombreCompleto.test(evt.key);
                      if (!isValid) {
                        addToast(nombreErrMsg, {
                          appearance: 'warning',
                        });

                        evt.preventDefault();
                      }
                    },
                  }}
                  rules={{
                    required: requiredMessage,
                  }}
                />
              </SimpleWrapper>
            </div>
          )}

          {inputs.includes('usuRFC') && (
            <div className="form-group">
              <SimpleWrapper
                label={
                  getOverrideInput('rfc', {
                    label: 'RFC',
                  }).label
                }
                name="datosCliente.rfc"
              >
                <TextInput
                  inputProps={{
                    name: 'datosCliente.rfc',
                  }}
                  rules={{
                    required: requiredMessage,
                    minLength: {
                      value: 9,
                      message: 'Debe ingresar mínimo 9 caracteres',
                    },
                  }}
                />
              </SimpleWrapper>
            </div>
          )}

          <div className="container-accidentes">
            <p
              className="disclaimer-form-datos"
              style={{ fontSize: '15px', fontFamily: 'Futura-Medium' }}
            >
              {disclaimer}
            </p>

            {inputs.includes('disclaimerTerminos') && (
              <a
                href={getOverrideInput('disclaimerTerminos').href}
                target="_blank"
                className="disclaimer-form-datos"
                style={{ fontSize: '15px', fontFamily: 'Futura-Medium' }}
              >
                Revisa nuestro aviso de privacidad aquí
              </a>
            )}
          </div>
        </div>
      </div>
      <InformacionAgente options={clavesAgente} />
      <div className="row mt-3 mb-4">
        <div className="col-12">
          <div className="row justify-content-center justify-content-md-end text-right">
            <div className="col-12">
              <button
                id="btn-ingresar"
                className="container-accidentes btn btn-block btn-primary btn-mis-datos text-uppercase ml-auto"
                type="submit"
              >
                {labelBtn}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MisDatosForm;
